import styled from "styled-components";
import { theme } from "../../../config";
import { Steps } from "antd";
const { Step } = Steps;

export const StepsStyled = styled(Step)`
  &
    .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title:after {
    background-color: white;
  }

  &.ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${theme.colors.secondary};
  }

  &.ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${theme.colors.secondary};
  }

  &.ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${theme.colors.secondary};
  }
  &.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background: ${theme.colors.white};
    color: ${theme.colors.secondary};
  }

  &.ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-icon
    .ant-steps-icon {
    color: ${theme.colors.secondary};
  }

  &.ant-steps-item-process .ant-steps-item-icon {
    border-color: ${theme.colors.secondary};
  }

  &.ant-steps-item-wait .ant-steps-item-icon {
    background-color: ${theme.colors.white};
  }

  .anticon svg {
    color: ${theme.colors.white};
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const LabelNumberGroup = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  white-space: nowrap;
`;

export const Number = styled.div<{
  isActive?: boolean;
  isFinished?: boolean;
  size?: string;
}>`
  ${(props) =>
    props.size === "small"
      ? "width: 24px; height: 24px;"
      : "width: 32px; height: 32px;"}
  padding-top: 3px;
  margin: 0 8px 0 0;
  border-radius: 50%;
  border: 1px solid ${(props) => (props.isActive ? "#00918e" : "transparent")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    props.isActive || props.isFinished ? "#00918e" : "rgba(0, 0, 0, 0.25)"};
  background-color: ${(props) => (props.isFinished ? "#00918e" : "white")};

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 10.8px;
    line-height: 18px;
  }
`;

export const Label = styled.div`
  margin: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props: { isActive?: boolean; isFinished?: boolean }) =>
    props.isActive || props.isFinished ? "#00918e" : "#4F4F4F"};
  ${(props: { isActive?: boolean; isFinished?: boolean }) =>
    (props.isActive || props.isFinished) &&
    "font-weight: 700; font-family: Orkney Medium;"}

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    line-height: 18px;
  }
`;

export const LineGuide = styled.div`
  height: 1px;
  background-color: ${(props: { isFinished?: boolean }) =>
    props.isFinished ? "#00918e" : "rgba(0, 0, 0, 0.25)"};
  flex: 1;
  margin: 0 20px;
`;
